import { createStore } from 'zustand'

import { ToolbarOptions, ToolbarStore } from './interface'

// 默认按钮宽度
const DEFAULT_ACTION_WIDTH = 50

const getVisibleGroups = (
  rawGroups: ToolbarStore['rawGroups'],
  moreGroups: ToolbarStore['moreGroups']
) => {
  return rawGroups.map((group, groupIndex) => {
    return moreGroups[groupIndex]
      ? group.filter(item => !moreGroups[groupIndex].includes(item))
      : group
  })
}

export const createToolbarStore = ({
  rawGroups,
  permanentGroup
}: ToolbarOptions) =>
  createStore<ToolbarStore>((set, get) => ({
    maxActionCount: 0,
    totalWidth: 0,
    setTotalWidth: (totalWidth: number) => {
      // 分割线的数量
      const dividerCount = get().visibleGroups.length - 1
      // 最大可展示的按钮数量，
      const maxActionCount =
        Math.floor(totalWidth / DEFAULT_ACTION_WIDTH) -
        dividerCount -
        permanentGroup.length
      set({
        totalWidth,
        maxActionCount
      })
    },
    rawGroups,
    permanentGroup,
    visibleGroups: rawGroups,
    moreButtonVisible: false,
    moreGroups: Array.from({ length: rawGroups.length }, (_, index) =>
      Array.from({ length: rawGroups[index].length }, () => null)
    ),
    _setMoreGroups(moreGroups) {
      const { rawGroups } = get()
      set({
        moreGroups,
        visibleGroups: getVisibleGroups(rawGroups, moreGroups),
        moreButtonVisible: moreGroups.flat().some(Boolean)
      })
    },
    addToMoreGroups: ({ groupIndex, itemIndex }) => {
      const { rawGroups, moreGroups, _setMoreGroups } = get()
      const newMoreGroups = [...moreGroups]
      const item = rawGroups[groupIndex][itemIndex]
      if (newMoreGroups[groupIndex].includes(item)) {
        return
      }
      newMoreGroups[groupIndex][itemIndex] = item
      _setMoreGroups(newMoreGroups)
    },
    rmFromMoreGroups: ({ groupIndex, itemIndex }) => {
      const { moreGroups, _setMoreGroups } = get()
      const newMoreGroups = [...moreGroups]
      newMoreGroups[groupIndex][itemIndex] = null
      _setMoreGroups(newMoreGroups)
    }
  }))
